import React from "react";
import { TextField, Box } from "@mui/material";
import TinyEditor from "src/components/ckeditor/Ckeditor";

const FoodMattersAndMindsetUI = ({
  addArray,
  setaddArray,
  setModalChangeExe,
  mainindex,
}) => {
  const handleChange = (e, index) => {
    const { name, value } = e.target;

    const list = [...addArray];
    list[index][name] = value;

    setaddArray(list);
    setModalChangeExe(true);
  };
  const handleChangeDes = (value) => {
    const list = [...addArray];
    list[mainindex]["description"] = value;

    setaddArray(list);
    setModalChangeExe(true);
  };

  return (
    <div className="my-2">
      <div className="mt-2 ">
        <div className="characters">
          <form onSubmit={() => {}}>
            <div
              style={{
                width: "100%",
                padding: "1px",
                position: "relative",
              }}
            >
              <div
                className=" my-1 workout-set-card w-100"
                style={{
                  width: "100%",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                  }}
                >
                  <div className="row">
                    <div
                      className={`col-sm-12 ${"col-md-7"} col-lg-7 d-flex align-items-center  mt-2 mt-md-0 mt-lg-0`}
                    >
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Title"
                        value={
                          addArray[mainindex].title
                            ? addArray[mainindex].title
                            : ""
                        }
                        name="title"
                        onChange={(e) => handleChange(e, mainindex)}
                        InputLabelProps={{
                          shrink: true,
                          style: { fontSize: "14px" },
                        }}
                        label="Title"
                        InputProps={{
                          style: {
                            fontSize: "13px",
                          },

                          inputProps: {
                            // readOnly: true,
                          },
                        }}
                        sx={{
                          borderRadius: "5px",

                          fontSize: "13px",
                          width: "100%",
                        }}
                      />
                    </div>
                    <div className="col-12 mt-3">
                      <h4>Detail Description</h4>
                      <TinyEditor
                        setDetailDescription={handleChangeDes}
                        detailDescriptionCk={addArray[mainindex].description}
                      />
                    </div>
                  </div>
                </Box>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default FoodMattersAndMindsetUI;
